// src/hooks/useSectorIntelligence.js
import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";

const BRANDING_SLOTS = [5, 21];
const AVERAGE_ORDER_VALUE = 10; // £10 per redemption

export default function useSectorIntelligence(sector, slots = []) {
  const [enrichedSlots, setEnrichedSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sector || sector === "UNKNOWN") {
      setEnrichedSlots(slots);
      return;
    }

    if (!slots || slots.length === 0) {
      return;
    }

    let cancelled = false;

    const run = async () => {
      try {
        setLoading(true);
        setError(null);

        // 1️⃣ Fetch household count
        const { data, error: err } = await supabase
          .from("postcode_sectors")
          .select("household_count")
          .eq("postcode_sector", sector)
          .maybeSingle();

        if (err) throw err;

        const hh = Number(data?.household_count ?? 0);
        const priceCalc = hh * 0.01;
        const predicted = Math.round(hh * 0.025);
        const roiValue = Math.round(predicted * AVERAGE_ORDER_VALUE);

        if (cancelled) return;

        // 2️⃣ Merge intelligence + RESTORE CATEGORY FIELDS
        const merged = slots.map((slot) => {
          const isBranding = BRANDING_SLOTS.includes(slot.slot_number);

          return {
            ...slot,

            // ⭐ RESTORED CATEGORY FIELDS
            category_name: slot.category_name || null,
            category_color: slot.category_color || "#6B7280",
            category_icon: slot.category_icon || null,

            // Intelligence fields
            households: isBranding ? null : hh,
            price: isBranding ? null : priceCalc,
            predicted_redemptions: isBranding ? null : predicted,
            roi_estimate: isBranding ? null : roiValue,
          };
        });

        setEnrichedSlots(merged);
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => (cancelled = true);
  }, [sector, slots]);

  return {
    enrichedSlots,
    loading,
    error,
  };
}
